import { IExtractedField } from 'types/db/ExtractedProForma';
import { RowValue } from '../../ExecutiveSummaryGenericTable/types';
import { ReturnsMetricId } from '../../layout/metrics';
import { BlockResolver } from '../../layout/types';
import {
    buildFieldMap, derivedBpsCell, derivedCell, ExtractedFieldKey, extractedCell, FieldMap, getField, hasDataWithPrefix,
} from './cells';
import { developmentSpreadBps, yieldOnCost } from './formulas';

const nameCell = (fieldMap: FieldMap, key: ExtractedFieldKey) => (): RowValue => {
    const field = getField(fieldMap, key);
    return { value: field && !field.cannotLocate ? field.value : '' };
};

export const extractedReturnsResolver = (fields: IExtractedField[]): BlockResolver<ReturnsMetricId> => {
    const fieldMap = buildFieldMap(fields);

    return {
        hasData: () => hasDataWithPrefix(fieldMap, 'returns.'),

        'unlevered.roi': extractedCell(fieldMap, 'returns.unlevered_roi'),
        'unlevered.emx': extractedCell(fieldMap, 'returns.unlevered_equity_multiple'),
        'unlevered.irr': extractedCell(fieldMap, 'returns.unlevered_irr'),

        'levered.roi': extractedCell(fieldMap, 'returns.levered_roi'),
        'levered.emx': extractedCell(fieldMap, 'returns.levered_equity_multiple'),
        'levered.irr': extractedCell(fieldMap, 'returns.levered_irr'),

        'lp.name': nameCell(fieldMap, 'returns.lp_name'),
        'lp.netProceeds': extractedCell(fieldMap, 'returns.lp_net_proceeds'),
        'lp.roi': extractedCell(fieldMap, 'returns.lp_roi'),
        'lp.emx': extractedCell(fieldMap, 'returns.lp_equity_multiple'),
        'lp.irr': extractedCell(fieldMap, 'returns.lp_irr'),

        'gp.name': nameCell(fieldMap, 'returns.gp_name'),
        'gp.netProceeds': extractedCell(fieldMap, 'returns.gp_net_proceeds'),
        'gp.roi': extractedCell(fieldMap, 'returns.gp_roi'),
        'gp.emx': extractedCell(fieldMap, 'returns.gp_equity_multiple'),
        'gp.irr': extractedCell(fieldMap, 'returns.gp_irr'),

        'yieldOnCost.untrended': extractedCell(fieldMap, 'returns.yield_on_cost_untrended'),
        'yieldOnCost.trended': derivedCell(() => yieldOnCost(fieldMap, '_trended'), 'percentage'),
        'yieldOnCost.sale': extractedCell(fieldMap, 'returns.yield_on_cost_at_sale'),

        'marketCapRate.untrended': extractedCell(fieldMap, 'returns.market_cap_rate_current'),
        'marketCapRate.trended': extractedCell(fieldMap, 'operations.cap_rate_trended'),
        'marketCapRate.sale': extractedCell(fieldMap, 'returns.market_cap_rate_at_sale'),

        'developmentSpread.untrended': extractedCell(fieldMap, 'returns.development_spread_untrended'),
        'developmentSpread.trended': derivedBpsCell(() => developmentSpreadBps(fieldMap, '_trended')),
        'developmentSpread.sale': extractedCell(fieldMap, 'returns.development_spread_at_sale'),

        'projectProfit.sale': extractedCell(fieldMap, 'returns.project_profit'),
        'projectProfitMargin.sale': extractedCell(fieldMap, 'returns.project_profit_margin'),
    };
};
